<template>
	<div>
		<!-- <HeaderBar title="不良事件"></HeaderBar> -->
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<!-- <van-cell-group title="不良事件名称（诊断/症状）"> -->
					<FormNormalInput label="事件名称" v-model="form.bq422.Bq422_002" required />
				<!-- </van-cell-group> -->
				<van-cell-group title="治疗时间">
					<van-row>
						<StaticSingleSelect label="发生阶段" :selectkey.sync="form.bq422.Bq422_003" :list="createTime"
							required />
						<van-row v-show="form.bq422.Bq422_003!=''">
							<van-col span="18">
								<FormNormalInput :label="form.bq422.Bq422_003" v-model="form.bq422.Bq422_00302"
									required />
							</van-col>
							<van-col span="6" class="unit">周</van-col>
						</van-row>
					</van-row>
				</van-cell-group>
				<!-- <van-cell-group title="严重程度"> -->
					<van-row>
						<van-col span="15">
						<StaticSingleSelect label="严重程度" :selectkey.sync="form.bq422.Bq422_004" :list="severityLevels"
							required />
						</van-col>
						<van-col span="9" class="unit"><van-button icon="eye-o" type="primary" plain size="small" @click="showInDialog=true">查看说明</van-button></van-col>
						
					</van-row>
				<!-- </van-cell-group> -->
				<van-cell-group title="与治疗药物因果关系">
					<van-row>
						<StaticSingleSelect label="因果关系" :selectkey.sync="form.bq422.Bq422_005"
							:list="drugRelationshipOptions" required />
					</van-row>
				</van-cell-group>
				<van-cell-group title="不良事件结局">
					<van-row>
						<StaticSingleSelect label="结局" :selectkey.sync="form.bq422.Bq422_006" :list="eventOutcomeList"
							required />
					</van-row>
				</van-cell-group>
				<van-cell-group title="不良事件持续时间">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="持续时间" v-model="form.bq422.Bq422_007" required />
						</van-col>
						<van-col span="6" class="unit">周</van-col>
					</van-row>
				</van-cell-group>
				<van-cell-group title="是否因不良事件停用治疗药物">
					<van-row>
						<StaticSingleSelect label="停用药物" :selectkey.sync="form.bq422.Bq422_008" :list="drugStopOptions"
							required />
					</van-row>
				</van-cell-group>
				<FormNormalUpload label="证明文件" ref="normalUpload" :infoGuid='form.bq422.guid' v-show="false">
				</FormNormalUpload>							
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq422.guid != ''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<!-- <div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div> -->
				<van-popup v-model="showInDialog" position="right" :style="{ width: '100%', 'height': '80%' }" closeable>
				<HeaderBar title="严重程度说明" fixed ></HeaderBar>
				<div class="center-box">
					
					<div style="margin: 16px; font-size: 0.9rem; line-height: 2.2rem;color: #333;">
						<font class="jbTitle">1级：</font>轻度；无临床症状或有轻微临床症状；仅有临床或实验室检查异常；无需治疗。<br>
						<font class="jbTitle">2级：</font>中度；需要较小、局部或非侵入性治疗；与年龄相符的工具性日常生活活动受限，（工具性日常生活活动指做饭、购物、打电话等）。<br>
						<font class="jbTitle">3级：</font>重度或有重要医学意义但不会立即危及生命；需要住院或延长住院时间；导致残疾；日常自理生活活动受限（日常自理生活活动指：洗澡、穿衣、脱衣、吃饭、如厕、服药等，且未卧床不起）。<br>
						<font class="jbTitle">4级：</font>危及生命；需要紧急治疗。<br>
						<font class="jbTitle">5级：</font>与AE有关的死亡。
					</div>

					<!-- <div style="margin: 16px; display: flex; justify-content: space-between;">

						<van-count-down :time="countDownTime" v-show="true"  format="ss"/>
					</div> -->
					<div style=" margin: 2rem; text-align: center; ">
						<van-button block type="info" plain @click="showInDialog=false" 
							style="width: 100%;">关闭</van-button>
					</div>
				</div>
			</van-popup>
			</van-form>
		</div>
	</div>
</template>


<script>
// import bus from '../bq400/page/js/eventBus.js'
export default {
	name: 's400Bq422Form',
	data() {
		return {
			form: {
				bq422: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间

					Bq001_018: this.bq001008, //患者编号
					Bq422_002: '', //事件名称
					Bq422_003: '', //
					Bq422_00302: '', //
					Bq422_004: '', //
					Bq422_005: '', //
					Bq422_006: '', //
					Bq422_007: '', //
					Bq422_008: '', //

				},
				sempFiles: [],
			},
			//发生时间
			createTime: [{ id: '治疗', name: '治疗' }, { id: '停药后', name: '停药后' },],
			//严重程度，5级
			severityLevels: [{ id: '1级', name: '1级' }, { id: '2级', name: '2级' }, { id: '3级', name: '3级' }, { id: '4级', name: '4级' }, { id: '5级', name: '5级' }],
			//与治疗药物因果关系
			drugRelationshipOptions: [{ id: '肯定有关', name: '肯定有关' }, { id: '很可能有关', name: '很可能有关' }, { id: '可能有关', name: '可能有关' }, { id: '可能无关', name: '可能无关' }, { id: '待评价', name: '待评价' }, { id: '无法评价', name: '无法评价' }],
			//不良事件结局
			eventOutcomeList: [{ id: '痊愈', name: '痊愈' }, { id: '部分缓解', name: '部分缓解' }, { id: '仍存在', name: '仍存在' }],
			//是否停用治疗药物
			drugStopOptions: [{ id: '是', name: '是' }, { id: '否', name: '否' }],
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq422/Save',
			savestate: false,
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			Bq422List: [],
			showInDialog: false,
		}
	},
	methods: {
		//保存按钮成功回调事件
		saveSucess: function () {
			//调用列表页的closeDialog方法
			// this.Back()
			this.savestate = true
			// this.$emit("closeAction")
		},
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq001018: this.bq400.Bq001_018
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq001/Info', args, function (d) {
				console.log(d)
			}, null, null, null);
		},
		//读取事件列表
		LoadList: function () {
			var that = this
			var args = {
				bq001018: this.bq400.Bq001_018,
				currentPage: 1,
				pageSize: 9999,
				recordCount: 0,
				menuid: '6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b'
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq422/List', args, function (
				d) {
				that.Bq422List = d.data
				if(d.data.length >= that.dataIndex){
					that.form.bq422 = that.Bq422List[that.dataIndex-1]
				}
			}, null, null, null)
		},
		//保存信息
		SaveInfo: function () {
			let that = this
			that.form.sempFiles = that.$refs.normalUpload.GetFileList()			
			that.$refs.btnSave.Save()
		},

	}, props: {
		bq001008: {
			type: String
		},
		disabled: {
			type: Boolean
		},
		closePage: {
			type: Function
		},
		dataIndex: {
			type: Number
		},
	},
	mounted() {
		//this.LoadInfo()
		this.form.bq422.Bq001_018 = this.bq400.Bq001_018
		this.LoadList()
	}
}
</script>

<style scoped>
.followRecord-title {
	padding-right: 10px;
}

.followRecord-tag {
	margin-right: 10px;
}

.unit {
	padding-top: 0.5rem;
	color:#999;
	font-size: 0.9em;
}
.jbTitle{
	font-size: 1.0rem;
	font-weight: 600;	
}
</style>
